import { type GenericListQueryKey, generateInfiniteQueryKey, generateListQueryKey } from '@pba/react-query';
import type { UsersQueryFilter } from './useGetUsers';

const localKey = ['users'] as const;

type UsersListQueryType = GenericListQueryKey<UsersQueryFilter>;

export const getUsersListQueryKey = (params: UsersListQueryType) =>
  generateListQueryKey({
    prefix: localKey,
  })(params);

export const getUsersInfiniteQueryKey = generateInfiniteQueryKey({
  generateListQueryKey: getUsersListQueryKey,
});
